package com.parmartechnologies.core.feature.chat.conversation.network

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class FindConversationRequest(
    @SerialName("user_id") val UserID: String,
    @SerialName("mobile_number") val mobile: String,
    @SerialName("dial_code") val dialCode: String,
)

@Serializable
data class FindUserRequest(
    @SerialName("user_id") val UserID: String,
    @SerialName("mobile_number") val mobile: String,
    @SerialName("dial_code") val dialCode: String,
)

@Serializable
data class FetchConversationRequest(
    @SerialName("user_id") val UserID: String,
    @SerialName("LastSyncDate") val LastSyncDate: String
)

@Serializable
data class FetchBusinessConversationRequest(
    @SerialName("business_id") val BusinessID: String,
    @SerialName("LastSyncDate") val LastSyncDate: String
)

@Serializable
data class CreateConversationRequest(
    @SerialName("user_id") var UserID: String = "",
    @SerialName("business_id") var BusinessID: String = "",
    @SerialName("store_id") var storeId: String = "",
    @SerialName("admin_users") var AdminUsers: List<String>? = null,
    @SerialName("participants") var Participants: List<String>? = null,
    @SerialName("group_name") var GroupName: String = "",
    @SerialName("group_description") var GroupDescription: String = "",
    @SerialName("status_description") var StatusDescription: String = "",
    @SerialName("last_message") var LastMessage: String = "",
    @SerialName("is_group") var ISGroup: Int = 0,
)

@Serializable
data class UpdateConversationRequest(
    @SerialName("_id") val id: String,
    @SerialName("user_id") val UserID: String,
    @SerialName("business_id") val BusinessID: String,
    @SerialName("name") val name: String,
    @SerialName("dial_code") val dialCode: String,
    @SerialName("mobile_number") val mobile: String,
    @SerialName("email_id") val email: String,
    @SerialName("device_id") val deviceID: String,
    @SerialName("is_deleted") var IsDeleted: Boolean,
    @SerialName("job_type_id") var JobTypeId: String,
    @SerialName("job_type_name") var JobTypeName: String,
)